import { render, staticRenderFns } from "./productInventory.vue?vue&type=template&id=4d6fc286&scoped=true&"
import script from "./productInventory.vue?vue&type=script&lang=js&"
export * from "./productInventory.vue?vue&type=script&lang=js&"
import style0 from "./productInventory.vue?vue&type=style&index=0&id=4d6fc286&prod&lang=css&"
import style1 from "./productInventory.vue?vue&type=style&index=1&id=4d6fc286&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fc286",
  null
  
)

export default component.exports